import React from 'react';
import { Information } from "src/components/login/Information";
import ResetPassword from '../@jumbo/components/Common/authComponents/ResetPassword';

const ResetPasswordPage = () => (
  <>
    <Information />
    <ResetPassword variant="standard" wrapperVariant="bgColor" />
  </>
);

export default ResetPasswordPage;
